module.exports = __webpack_public_path__ + "static/media/icon_menu_dashboard.546b4bef.svg";